import React, { useImperativeHandle, useRef, forwardRef } from "react";
import cx from "clsx";
import { Editor } from "@tinymce/tinymce-react";
import { INIT, INIT_MARKDOWN } from "./TextEditor.consts";
import "./TextEditor.scss";
import "./tinymce.css";

/**
 * @param {Object} param0
 * @param {string?} param0.value
 * @param {(value: string) => void} param0.onChange
 * @param {string?} param0.className
 * @param {boolean?} param0.isDisabled
 * @param {RawEditorOptions?} param0.init
 * @param {boolean?} param0.markdownMode
 *
 */
export const TextEditor = forwardRef(
  ({
    value,
    onChange,
    className,
    isDisabled = false,
    init = {},
    ref,
    markdownMode = false,
  }) => {
    const editorRef = useRef(null);

    useImperativeHandle(ref, () => ({
      getEditor: () => editorRef.current,
      getHtml: () => editorRef.current?.getContent?.() || "",
      getText: () => {
        const tmp = document.createElement("div");
        tmp.innerHTML = editorRef.current?.getContent?.() || "";
        return tmp.textContent || "";
      },
      focus: () => editorRef.current?.focus?.(),
    }));

    const initConfig = markdownMode ? INIT_MARKDOWN : INIT;

    return (
      <div
        className={cx(
          "TextEditor-shared",
          {
            "TextEditor-shared__disabled": isDisabled,
          },
          className,
        )}
      >
        <Editor
          onInit={(evt, editor) => {
            editorRef.current = editor;
          }}
          value={value}
          onEditorChange={onChange}
          init={{
            ...initConfig,
            ...init,
          }}
        />
      </div>
    );
  },
);
